// 发生错误重定向到主页的错误页面
import React from 'react';
import './errorPage.scss';
import '../../apis/base';
import { withTranslation } from 'react-i18next';
import Event, { EVENTS } from '../../util/event';

export default withTranslation()(class ErrorPage extends React.Component {
  constructor(props) {
    super(props);
    this.timer = React.createRef();
    this.state = {
      countdown: 5,
    };
  }

  backToHome = (e) => {
    e && e.preventDefault && e.preventDefault();
    clearInterval(this.timer.current);
    this.props.history.push('/');
  }

  componentDidMount() {
    this.props?.beforeKeyDownHandle && this.props?.beforeKeyDownHandle('click', this.backToHome);
    Event.on(EVENTS.KEY_DOWN_CLICK, this.backToHome);
    this.timer.current = setInterval(() => {
      if (this.state.countdown > 0) {
        this.setState({
          countdown: this.state.countdown - 1,
        });
      } else {
        clearInterval(this.timer.current);
        this.props.history.push('/');
      }
    }, 1000);
  }

  componentWillUnmount() {
    Event.off(EVENTS.KEY_DOWN_CLICK, this.backToHome);
  }

  render() {
    return (
      <div className='redirectPage' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100vw', height: '100vh' }}>
        <div className='pageErrImg'>
        </div>
        <div className='errorTips'>
          {this.props.t('没有相关内容，请选择其他')}
        </div>
        <div className='timerTips'>
          <button className='returnToHomeBtn'>
            {this.props.t('返回首页')}{`(${this.state.countdown}s)`}
          </button>
        </div>
      </div>
    );
  }
});
